import React from 'react';
import { COMMUNITY_RESOURCE_ICONS, DEFAULT_RESOURCE_ICON } from '@/assets/admin/CommunityResourceIcons';

interface ResourceIconProps {
  /** Preferred prop name. Matches the residents/shared `ResourceIcon` API. */
  iconKey?: string;
  /** Legacy alias for `iconKey`. Kept for backwards compatibility. */
  icon?: string;
  size?: number;
  color: string;
}

export const ResourceIcon: React.FC<ResourceIconProps> = ({
  iconKey,
  icon,
  size = 16,
  color,
}) => {
  const key = iconKey ?? icon;
  const IconComp = (key && (COMMUNITY_RESOURCE_ICONS as any)[key]) || DEFAULT_RESOURCE_ICON;
  return <IconComp width={size} height={size} color={color} />;
};


